module.exports = __webpack_public_path__ + "img/d_shc.66d4bad2.jpg";